import { APP_FEATURES, Feature, FeatureDto } from 'modules/organizer/domain/interfaces/available-feature';

/**
 * Ответ `features(tournamentId)` → словарь «фича → включена».
 *
 * Бэкенд перечисляет только те фичи, о которых знает: фича, которой в ответе нет,
 * считается выключенной, а не неизвестной — потребители читают `data[feature]` как boolean.
 */
export function mapAvailableFeatures(dtos: FeatureDto[]): Feature {
  const features = Object.fromEntries(APP_FEATURES.map((feature) => [feature, false])) as Feature;

  dtos.forEach(({ feature, isEnabled }) => {
    features[feature] = isEnabled;
  });

  return features;
}
